/**
 * Module dependencies.
 */

import createCache from '@emotion/cache';

/**
 * Emotion cache instance.
 */

export const emotionCacheInstance = createCache({ key: 'css', prepend: true });
